/**
 *
 * UserManagement
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ModalCreateUser from "components/ModalCreateUser"
import ModalDeleteSimple from "components/ModalDeleteSimple"
import { Tabs, Table, Button } from "antd"
import reducer from "./reducer"
import saga from "./saga"

import { makeSelectListUsers, makeSelectIsLoadingListUsers } from "./selectors"
import {
  getUsersWatcher,
  deleteUserWatcher,
  switchUserWatcher,
  updateInfoUserWatcher,
} from "./actions"
import plusIcon from "../../../images/plus.svg"

import Ambassador from "./Ambassador"

import Leader from "./Leader"

import columns from "./columns"
import "./index.less"
import {
  ADMINISTRATOR_USERS,
  AMBASSADOR_USERS,
  LEADER_USERS,
  ROLE_COMPANY_SUPER_ADMIN,
} from "../../../utils/constants"
import {
  isAdminMandu,
  isModuleBySlug,
  LOCAL_ACTIVE_ROL,
} from "../../../utils/storage"
import { buttonAction_btns } from "../../../components/Snowplow/config2"

const { TabPane } = Tabs

/* eslint-disable react/prefer-stateless-function */
export class UserManagement extends React.Component {
  state = {
    modalCreateUser: false,
    modalDeleteSimple: false,
    userSelected: {},
    tab: 1,
  }

  componentDidMount = () => {
    this.props.getUsersWatcher()
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  callback = (key) => {
    this.setState({ tab: key })
  }

  render() {
    const isAdministratorUsers = isModuleBySlug(ADMINISTRATOR_USERS)
    const isLeaderUsers = isModuleBySlug(LEADER_USERS)
    const isAmbassadorUsers = isModuleBySlug(AMBASSADOR_USERS)
    return (
      <div className="container-usermanagement">
        <Tabs
          animated={false}
          className="container-usermanagement__tabs"
          defaultActiveKey="1"
          onChange={this.callback}
          style={{ overflow: "initial" }}>
          {isAdministratorUsers && (
            <TabPane
              tab="Administradores"
              key="1"
              className="container-usermanagement__tab">
              {(LOCAL_ACTIVE_ROL() == ROLE_COMPANY_SUPER_ADMIN ||
                isAdminMandu()) && (
                <div
                  className="container-usermanagement__actions"
                  style={{ top: 8 }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      this.setState({ modalCreateUser: true })
                      buttonAction_btns("Crear usuario")
                    }}>
                    <img src={plusIcon} />
                  </Button>
                </div>
              )}
              <div className="container-usermanagement__tab-title color-black">
                Usuarios administradores{" "}
                <span className="color-gray-low">
                  (
                  {Array.isArray(this.props.listUsers)
                    ? this.props.listUsers.length
                    : 0}
                  )
                </span>
              </div>
              <div className="container-usermanagement__tab-description color-black">
                Los usuarios <span>superadministradores</span> y{" "}
                <span>administradores</span> poseen visibilidad de toda la
                plataforma y acceso a todas sus secciones. Pueden cambiar
                aspectos de la configuración dentro del Panel de Control. Solo
                los <span>superadministradores</span> pueden crear usuarios{" "}
                <span>administradores.</span>
              </div>
              <div>
                <Table 
                  className="container-usermanagement__table"
                  rowKey={(record) => record.id}
                  dataSource={
                    Array.isArray(this.props.listUsers)
                      ? this.props.listUsers
                      : []
                  }
                  columns={columns(
                    this.setStateFrom,
                    this.props.switchUserWatcher
                  )}
                  loading={this.props.isLoadingListUsers}
                  pagination={{
                    pageSizeOptions: ["15", "25", "50", "100"],
                    showSizeChanger: true,
                    size: "default",
                    defaultPageSize: 15,
                  }}
                />
              </div>
            </TabPane>
          )}

          {isAmbassadorUsers && (
            <TabPane
              tab="Embajadores"
              key="2"
              className="container-usermanagement__tab">
              <Ambassador {...this.props} />
            </TabPane>
          )}

          {isLeaderUsers && (
            <TabPane
              tab="Líderes"
              key="3"
              className="container-usermanagement__tab">
              <Leader {...this.props} />
            </TabPane>
          )}
        </Tabs>
        <ModalCreateUser
          updateInfoUserWatcher={this.props.updateInfoUserWatcher}
          userSelected={this.state.userSelected}
          setStateFrom={this.setStateFrom}
          visible={this.state.modalCreateUser}
          getUsers={this.props.getUsersWatcher}
        />
        <ModalDeleteSimple
          visible={this.state.modalDeleteSimple}
          content={
            <p>
              ¿Estás seguro de que deseas eliminar a{" "}
              <span>{`${this.state.userSelected.first_name} ${this.state.userSelected.last_name}`}</span>{" "}
              como{" "}
              {this.state.userSelected.id_role == ROLE_COMPANY_SUPER_ADMIN
                ? "superadministrador"
                : "administrador"}
              .
            </p>
          }
          onOk={() => {
            this.props.deleteUserWatcher(this.state.userSelected.id)
            this.setState({ modalDeleteSimple: false, userSelected: {} })
          }}
          onCancel={() => {
            this.setState({ modalDeleteSimple: false, userSelected: {} })
          }}
        />
      </div>
    )
  }
}

UserManagement.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  listUsers: makeSelectListUsers(),
  isLoadingListUsers: makeSelectIsLoadingListUsers(),
})

function mapDispatchToProps(dispatch) {
  return {
    getUsersWatcher: () => dispatch(getUsersWatcher()),
    deleteUserWatcher: (params) => dispatch(deleteUserWatcher(params)),
    switchUserWatcher: (params) => dispatch(switchUserWatcher(params)),
    updateInfoUserWatcher: () => dispatch(updateInfoUserWatcher()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "userManagement", reducer })
const withSaga = injectSaga({ key: "userManagement", saga })

export default compose(withReducer, withSaga, withConnect)(UserManagement)
